import { TableHeaderCategoryConfig } from "../../../../components/tables/tableContext/TableContext";
import { parseDrugCode } from "../../../../helpers/commonHelper";
import { QuarantinedProductsToReturnStockInterface } from "../../../../redux/interfaces/inventory.interface";
import { dateToString } from "../../../../utils/dateAndTime";

export const returningProductsToProviderTableHeader: TableHeaderCategoryConfig[] =
  [
    {
      label: "",
      value: "selected",
      minW: 125,
    },
    {
      label: "Denumire produs",
      value: "numeProdusErp",
      minW: 125,
    },
    {
      label: "Cod grupa",
      value: "codGrupa",
      minW: 125,
    },
    {
      label: "Cod produs",
      value: "codProdus",
      minW: 125,
    },
    {
      label: "Lot",
      value: "lot",
      minW: 125,
    },
    {
      label: "Data expirare",
      value: "dataExpirare",
      minW: 125,
    },
    {
      label: "Furnizor",
      value: "provider",
      minW: 125,
    },
    {
      label: "Cantitate",
      value: "cantitate",
      minW: 50,
    },
    {
      label: "Locatie",
      value: "reason",
      minW: 100,
    },
  ];

export const getReturningProductsToProviderTableData: any = (
  inventoryReturningProductsToProviderList: QuarantinedProductsToReturnStockInterface[],
) =>
  inventoryReturningProductsToProviderList?.map((item) => {
    return {
      id: item.idActivCel,
      crudData: item,
      data: [
        {
          checkbox: true,
        },
        {
          title: item.numeProdusErp,
        },
        {
          title: item.codGrupa ? parseDrugCode(item.codGrupa) : "-",
        },
        {
          title: item.codProdus,
        },
        {
          title: item.lot,
        },
        {
          badges: [
            {
              badgeText: `${dateToString(item.dataExpirare ?? "-")}`,
              badgeColor: "light-danger",
            },
          ],
        },
        {
          badges: item.furnizori.map((furnizor) => {
            return {
              badgeText: furnizor.label,
              badgeColor: "light-info",
            };
          }),
        },
        {
          title: item.cantitate,
        },
        {
          title: item.locatie,
        },
      ],
    };
  });
